/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CartLayout_user$ref = any;
export type CartContainer_user$ref = any;
export type CartContainer_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": CartLayout_user$ref;
    readonly " $refType": CartContainer_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartContainer_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "CartLayout_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'caaa445902d4ffa3886dae0168ab6dcb';
export default node;
